import { isDssType } from '@1delta/lender-registry'
import type { TermAdapter } from './index'

/**
 * dss — a MakerDAO-shaped CDP (`SKY` itself and forks such as `USDD`). The
 * stability fee is set by GOVERNANCE per ilk with no utilization curve, so the
 * rate can move with no market signal at all.
 */
export const dssAdapter: TermAdapter = {
  id: 'dss',
  matches: isDssType,
  profileId: () => 'dss.cdp@v1',
  build: () => ({
    borrow: {
      rate: { kind: 'variable-managed', source: 'governance', isLocked: false },
      debtShape: 'accruing',
      exit: {
        earlyRepay: 'free',
        atMaturityCost: 'accrued',
        lateBehaviour: 'none',
        partialAllowed: true,
      },
      liquidation: { trigger: 'price', seizure: 'proportional' },
      counterparty: { kind: 'cdp', solvency: 'overcollateralized' },
    },
    constraints: {
      positionModel: 'cdp-id',
      positionIdMeaning: 'The CDP id issued by the manager for this ilk.',
    },
  }),
}
